import React from 'react';
import background from '../../assets/vote.jpg';
import ReusableAskearth from '../../components/ReusableAskearth/ReusableAskearth';

class PromptRegister extends React.Component {
  render () { 
   return(
  
  <ReusableAskearth             
    
        tag="TAKE ACTION"
        description01="Register to vote"

        
        background={background}
     />
  
  );
 }
}   

export default PromptRegister;